import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import About from "@/components/site/About";
import AGSMeaning from "@/components/site/AGSMeaning";
import FounderGuarantee from "@/components/site/FounderGuarantee";
import Services from "@/components/site/Services";
import TeamInAction from "@/components/site/TeamInAction";
import WhyAGS from "@/components/site/WhyAGS";
import HowItWorks from "@/components/site/HowItWorks";
import SiteLeadership from "@/components/site/SiteLeadership";
import Compliance from "@/components/site/Compliance";
import GreenPledge from "@/components/site/GreenPledge";
import InHouseExpertise from "@/components/site/InHouseExpertise";
import FAQ from "@/components/site/FAQ";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-white text-[#050B14]">
      <Navigation />
      <main>
        <Hero />
        <TrustStrip />
        <About />
        <AGSMeaning />
        <FounderGuarantee />
        <Services />
        <TeamInAction />
        <WhyAGS />
        <HowItWorks />
        <SiteLeadership />
        <Compliance />
        <InHouseExpertise />
        <GreenPledge />
        <FAQ />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
